import { supabase } from '../lib/supabase';

import { presenceFromProfile } from '../lib/presence';

import type { Profile } from '../types/database';

import type { ResolvedPresence } from '../lib/presence';



export type PresenceFields = Pick<

  Profile,

  'id' | 'last_seen_at' | 'availability_status' | 'prefs_show_activity'

>;



export const presenceService = {

  async heartbeat(): Promise<{ ok: boolean; error?: string }> {

    const { error } = await supabase.rpc('heartbeat_presence');

    if (error) return { ok: false, error: error.message };

    return { ok: true };

  },



  async markOffline(): Promise<void> {

    try {

      await supabase.rpc('mark_presence_offline');

    } catch {

      /* best effort on sign-out */

    }

  },



  /** Batch-fetch presence fields for chat lists and profiles. */

  async getForUserIds(userIds: string[]): Promise<Map<string, ResolvedPresence>> {

    const map = new Map<string, ResolvedPresence>();

    const ids = Array.from(new Set(userIds.filter(Boolean)));

    if (ids.length === 0) return map;



    const { data, error } = await supabase

      .from('profiles')

      .select('id, last_seen_at, availability_status, prefs_show_activity')

      .in('id', ids);



    if (error || !data) return map;



    for (const row of data as PresenceFields[]) {

      map.set(row.id, presenceFromProfile(row));

    }

    return map;

  },

};


